'use client'

import { useReportError } from '@/lib/sentry/use-report-error'
import { isTransientNetworkError } from '@/lib/is-transient-network-error'
import ConnectionLostNotice from '@/components/errors/ConnectionLostNotice'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useReportError(error)
  // #920: a dropped connection gets plain copy and a reload, not the raw message.
  if (isTransientNetworkError(error)) return <ConnectionLostNotice homeHref="/" homeLabel="Go home" />

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Something went wrong</h2>
        <p className="text-gray-600 mb-6">
          {error.message || 'An unexpected error occurred. Please try again.'}
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={reset}
            className="px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 font-semibold"
          >
            Try again
          </button>
          <a
            href="/"
            className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 font-semibold"
          >
            Go home
          </a>
        </div>
      </div>
    </div>
  )
}
